import { render, staticRenderFns } from "./promocionesArticulo.vue?vue&type=template&id=d34d43b6&scoped=true&"
import script from "./promocionesArticulo.vue?vue&type=script&lang=js&"
export * from "./promocionesArticulo.vue?vue&type=script&lang=js&"
import style0 from "./promocionesArticulo.vue?vue&type=style&index=0&id=d34d43b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d34d43b6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/ALIO/APP/APPVentas/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VList } from 'vuetify/lib'
import { VListTile } from 'vuetify/lib'
import { VSubheader } from 'vuetify/lib'
installComponents(component, {VContainer,VFlex,VLayout,VList,VListTile,VSubheader})
